/* Product page Rincón — galería, paquetes, botón que abre Releasit y barra fija.
   Se carga desde cada sección rx-*; el candado evita que corra dos veces. */
(function () {
  if (window.__rxProducto) return;
  window.__rxProducto = true;

  function compra() { return document.querySelector('[data-rx-compra]'); }

  // Abre el formulario contra entrega de Releasit. Si Releasit no está, manda el pedido al carrito
  // para no perder la venta; y si tampoco hay formulario, lleva a la zona de compra.
  function pedir() {
    var rsi = document.querySelector('.rx-releasit #rsi_buy_now_button') || document.querySelector('#rsi_buy_now_button:not(.rsi_floating)') || document.querySelector('#rsi_buy_now_button');
    if (rsi) { rsi.click(); marcarOfertaEnReleasit(); return; }
    var form = document.querySelector('form[data-rx-form]');
    if (form) { form.submit(); return; }
    var c = compra();
    if (c) c.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  // Releasit abre con la oferta que tenga preseleccionada. Aquí se marca la que el cliente eligió en la
  // página (1 o 2 piezas), para que el total del formulario sea el mismo que decía el botón.
  function cantidadElegida() {
    var b = document.querySelector('[data-rx-paquete][aria-pressed="true"]');
    return b ? parseInt(b.getAttribute('data-cantidad'), 10) || 1 : 1;
  }
  function indiceDeOferta(cantidad) {
    var c = compra();
    var pid = c ? String(c.getAttribute('data-rx-producto') || '') : '';
    var lista = window._RSI_COD_FORM_QUANTIY_OFFERS || [];
    for (var i = 0; i < lista.length; i++) {
      var o = lista[i];
      if (!o || !o.isActive || !o.pIds || o.pIds.map(String).indexOf(pid) === -1) continue;
      for (var k = 0; k < (o.offers || []).length; k++) if (o.offers[k].qty === cantidad) return k;
    }
    return cantidad - 1;
  }
  function marcarOfertaEnReleasit() {
    var cantidad = cantidadElegida();
    var indice = indiceDeOferta(cantidad);
    var intentos = 0;
    var t = setInterval(function () {
      intentos++;
      var r = document.querySelector('#rsi_form_wrapper #quantity_offer_' + indice);
      if (r) {
        clearInterval(t);
        if (!r.checked) (r.closest('label') || r).click();
      } else if (intentos > 30) {
        clearInterval(t);
      }
    }, 100);
  }

  function elegirPaquete(btn) {
    var grupo = btn.closest('[data-rx-paquetes]');
    if (!grupo) return;
    grupo.querySelectorAll('[data-rx-paquete]').forEach(function (b) {
      b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
    });
    var precio = btn.getAttribute('data-precio') || '';
    var linea = btn.getAttribute('data-linea') || '';
    var cantidad = btn.getAttribute('data-cantidad') || '1';
    document.querySelectorAll('[data-rx-total]').forEach(function (el) { el.textContent = precio; });
    document.querySelectorAll('[data-rx-linea]').forEach(function (el) { el.textContent = linea; });
    document.querySelectorAll('form[data-rx-form] input[name="quantity"]').forEach(function (el) { el.value = cantidad; });
  }

  function elegirPorCantidad(cantidad) {
    var btn = document.querySelector('[data-rx-paquete][data-cantidad="' + cantidad + '"]');
    if (btn) elegirPaquete(btn);
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    var p = t.closest('[data-rx-pedir]');
    if (p) {
      e.preventDefault();
      var q = p.getAttribute('data-rx-cantidad');
      if (q) elegirPorCantidad(q);
      pedir();
      return;
    }
    var k = t.closest('[data-rx-paquete]');
    if (k) { elegirPaquete(k); return; }
    var g = t.closest('[data-rx-gal-ir]');
    if (g) { irA(g.closest('[data-rx-gal]'), g.getAttribute('data-rx-gal-ir')); }
  });

  // Galería: deslizar con el dedo (scroll-snap), flechas y miniaturas.
  function slides(gal) { return gal.querySelectorAll('.rx-gal-slide'); }
  function actual(gal) {
    var track = gal.querySelector('.rx-gal-track');
    return track && track.clientWidth ? Math.round(track.scrollLeft / track.clientWidth) : 0;
  }
  function irA(gal, destino) {
    if (!gal) return;
    var track = gal.querySelector('.rx-gal-track');
    var n = slides(gal).length;
    if (!track || !n) return;
    var i = actual(gal);
    if (destino === 'prev') i = (i - 1 + n) % n;
    else if (destino === 'next') i = (i + 1) % n;
    else i = Math.max(0, Math.min(n - 1, parseInt(destino, 10) || 0));
    track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
  }
  function pintar(gal) {
    var i = actual(gal);
    var n = slides(gal).length;
    var cont = gal.querySelector('[data-rx-gal-cont]');
    if (cont) cont.textContent = (i + 1) + ' / ' + n;
    gal.querySelectorAll('.rx-thumb').forEach(function (th, k) {
      th.setAttribute('aria-current', k === i ? 'true' : 'false');
    });
  }
  function iniciarGalerias(raiz) {
    (raiz || document).querySelectorAll('[data-rx-gal]').forEach(function (gal) {
      if (gal.__rx) return;
      gal.__rx = true;
      var track = gal.querySelector('.rx-gal-track');
      if (!track) return;
      var espera;
      track.addEventListener('scroll', function () {
        clearTimeout(espera);
        espera = setTimeout(function () { pintar(gal); }, 60);
      }, { passive: true });
      pintar(gal);
    });
  }

  // Barra fija: aparece cuando el botón principal sale de la pantalla hacia arriba.
  function iniciarBarra() {
    var barra = document.querySelector('[data-rx-barra]');
    var cta = document.querySelector('[data-rx-cta-principal]');
    if (!barra || !cta || barra.__rx || !('IntersectionObserver' in window)) return;
    barra.__rx = true;
    new IntersectionObserver(function (entradas) {
      var en = entradas[0];
      var pasado = !en.isIntersecting && en.boundingClientRect.top < 0;
      barra.classList.toggle('is-on', pasado);
      barra.setAttribute('aria-hidden', pasado ? 'false' : 'true');
    }).observe(cta);
  }

  function iniciar(raiz) {
    iniciarGalerias(raiz);
    iniciarBarra();
    var pre = document.querySelector('[data-rx-paquete][aria-pressed="true"]');
    if (pre) elegirPaquete(pre);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { iniciar(); });
  else iniciar();
  document.addEventListener('shopify:section:load', function (e) { iniciar(e.target); });
})();
